import { PieChartData } from "@evergis/charts";

import { formatAttributeValue } from "../../../utils/formatAttributeValue";
import { FeatureAttribute } from "../components/Attributes/FeatureAttributeField";

export const pieChartTooltipFromAttributes = (data: PieChartData[], attributes: FeatureAttribute[]): string => {
  const attribute = attributes.find(({ name }) => name === data[0].name);
  const renderValue = attribute
    ? formatAttributeValue(attribute.type, data[0].value, attribute.stringFormat)
    : data[0].value;

  return `${attribute?.alias || data[0].name} ${renderValue}`;
};
